(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["corporate-contact"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const mobileQuery = window.matchMedia('(max-width: 749px)');

    function syncLogoMarquees() {
      document.querySelectorAll('[data-corporate-contact-logos]').forEach((viewport) => {
        const track = viewport.querySelector('.corporate-contact__logo-track');
        if (!track) return;

        const clone = track.querySelector('[data-logo-marquee-clone]');

        if (mobileQuery.matches) {
          if (!clone) {
            const source = track.querySelector('.corporate-contact__logo-row');
            if (!source) return;

            const copy = source.cloneNode(true);
            copy.setAttribute('data-logo-marquee-clone', '');
            copy.setAttribute('aria-hidden', 'true');
            copy.querySelectorAll('[id]').forEach((node) => node.removeAttribute('id'));
            track.appendChild(copy);
          }

          viewport.classList.add('is-marquee');
          return;
        }

        clone?.remove();
        viewport.classList.remove('is-marquee');
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', syncLogoMarquees);
    } else {
      syncLogoMarquees();
    }

    mobileQuery.addEventListener('change', syncLogoMarquees);
    document.addEventListener('shopify:section:load', syncLogoMarquees);
 const corporateWebhook = 'https://hook.us2.make.com/1rhtw4kq0jguunns332ojw6hknkdpc31';

function connectCorporateForms() {
  document.querySelectorAll('.corporate-contact__form').forEach((form) => {
    if (form.dataset.makeWebhookConnected === 'true') return;

    form.dataset.makeWebhookConnected = 'true';

    form.addEventListener('submit', (event) => {
      // Ignore double clicks so the lead isn't sent twice
      const now = Date.now();
      if (form.dataset.submittedAt && now - Number(form.dataset.submittedAt) < 8000) {
        event.preventDefault();
        return;
      }
      form.dataset.submittedAt = String(now);

      // Read by snippets/contact-success-redirect.liquid when Shopify returns with ?contact_posted=true
      const redirectHost = form.closest('[data-success-redirect]');
      try {
        if (redirectHost) {
          sessionStorage.setItem(
            'rc_contact_submitted',
            JSON.stringify({
              redirect: redirectHost.dataset.successRedirect,
              inquiry_type: redirectHost.dataset.inquiryType,
              path: window.location.pathname,
              at: Date.now()
            })
          );
        } else {
          sessionStorage.removeItem('rc_contact_submitted');
        }
      } catch (e) {}

      const payload = new URLSearchParams();

      payload.append('name', form.querySelector('[name="contact[name]"]')?.value || '');
      payload.append('company', form.querySelector('[name="contact[Company name]"]')?.value || '');
      payload.append('email', form.querySelector('[name="contact[email]"]')?.value || '');
      payload.append('phone', form.querySelector('[name="contact[Phone]"]')?.value || '');
      payload.append('topic', form.querySelector('[name="contact[topic]"]')?.value || '');
      payload.append('message', form.querySelector('[name="contact[body]"]')?.value || '');
      payload.append(
        'inquiry_type',
        form.querySelector('[name="contact[Inquiry type]"]')?.value || 'Corporate Gifting'
      );
      payload.append('page_url', window.location.href);

      fetch(corporateWebhook, {
        method: 'POST',
        body: payload,
        keepalive: true
      }).catch(() => {});

      const sheetWebhook = form.closest('[data-sheet-webhook]')?.dataset.sheetWebhook;
      if (sheetWebhook) {
        fetch(sheetWebhook, {
          method: 'POST',
          mode: 'no-cors',
          body: payload,
          keepalive: true
        }).catch(() => {});
      }
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', connectCorporateForms);
} else {
  connectCorporateForms();
}

document.addEventListener('shopify:section:load', connectCorporateForms); })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
